import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import ClipNoteCard from './clip-note-card';
import HighlightCard from './highlight-card';
import ReportCard from './report-card';
import TranscriptCard from './transcript-card';
import typeEntity from '../../constants/entity-type';

const SearchResultCard = (props) => {
  const {
    highlight,
    isSelectable,
    onCardClick,
    onClick,
    selected,
  } = props;

  const { searchableType } = highlight;

  const searchHighlights = _.get(highlight, 'searchHighlights') || [];

  return (
    <>
      {searchableType === typeEntity.TEST_SESSION_NOTE
          // Accepts TestsessionNote of note, clip
          && (
            <ClipNoteCard
              isSelectable={isSelectable}
              selected={selected}
              highlight={highlight}
              onCardClick={onCardClick}
              handleClick={onClick}
              searchHighlights={searchHighlights}
            />
          )}

      {searchableType === typeEntity.REPORT
      // Accepts Reports
            && (
              <ReportCard
                isSelectable={isSelectable}
                highlight={highlight}
                selected={selected}
                onCardClick={onCardClick}
                handleClick={onClick}
                searchHighlights={searchHighlights}
              />
            )}

      {searchableType === typeEntity.TAG_HIGHLIGHT
      // Accepts Highlights from Search page
            && (
              <HighlightCard
                isSelectable={isSelectable}
                highlight={highlight}
                selected={selected}
                onCardClick={onCardClick}
                handleClick={onClick}
                searchHighlights={searchHighlights}
              />
            )}

      {(searchableType === typeEntity.TEST_SESSION_ANSWER || searchableType === typeEntity.TEST_SESSION_SPEAKER)
      // Accepts Transcript
              && (
                <TranscriptCard
                  isSelectable={isSelectable}
                  highlight={highlight}
                  selected={selected}
                  onCardClick={onCardClick}
                  handleClick={onClick}
                  searchHighlights={searchHighlights}
                />
              )}
    </>
  );
};

SearchResultCard.propTypes = {
  highlight: PropTypes.shape({
    searchableType: PropTypes.string,
  }).isRequired,
  isSelectable: PropTypes.bool,
  onCardClick: PropTypes.func,
  onClick: PropTypes.func,
  selected: PropTypes.bool,
};

SearchResultCard.defaultProps = {
  isSelectable: false,
  selected: false,
  onCardClick: () => {},
  onClick: () => {},
};

export default SearchResultCard;
